import React from "react";

import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Home from "./screens/Home";
import CadastroSucesso from "./screens/CadastroSucesso";

import createGlobalStyle from "./styles/global";

import NaoEncontrado from "./screens/NaoEncontrado";

import { QueryParamProvider } from "use-query-params";
import { ReactRouter6Adapter } from "use-query-params/adapters/react-router-6";
import { parse, stringify } from "query-string";

import Contato from "./screens/Contato";

import Ajuda from "./screens/Ajuda";


import AlgoDeuErrado from "./screens/AlgoDeuErrado";

import InclusaoCidadeEstado from "./screens/InclusaoCidadeEstado";
import SemPermissao from "./screens/SemPermissao";

import InfoEmpreendimento from "./screens/InfoEmpreendimento";


import PagamentoVenda from "./screens/PagamentoVenda";

import Agradecimentos from "./screens/Agradecimentos";
import ContatoVendaPersonalizada from "./screens/ContatoVendaPersonalizada";
import QueroViajar from "./screens/QueroViajar";
import Venda from "./screens/Venda";
import Periodos from "./screens/Periodos";
import AgradecimentoViagem from "./screens/AgradecimentoViagem";
import Compra from "./screens/Compra";
import SolicitacaoReserva from "./screens/SolicitacaoReserva";

const GlobalStyle = createGlobalStyle;

const element = document.getElementById("root");
const root = createRoot(element!);
root.render(
  <BrowserRouter>
    <QueryParamProvider
      adapter={ReactRouter6Adapter}
      options={{
        searchStringToObject: parse,
        objectToSearchString: stringify,
      }}
    >
      
      <Routes>
        <Route path="/" element={<Home />} />

        <Route path="inclusaoCidadeEstado" element={<InclusaoCidadeEstado />} />
   
   
        <Route path="agradecimentocadastrointeresseviagem" element={<AgradecimentoViagem />} />
        <Route path="queroviajar" element={<QueroViajar />} />
        <Route path="pagamentoVenda" element={<PagamentoVenda />} />
        <Route path="contatovendapersonalizada" element={<ContatoVendaPersonalizada />} />
        <Route path="agradecimentos" element={<Agradecimentos />} />
      
        <Route path="naoEncontrado" element={<NaoEncontrado />} />
        <Route path="cadastroSucesso" element={<CadastroSucesso />} />
        <Route path="venda" element={<Venda />} />
        <Route path="compra" element={<Compra />} />
        <Route path="Periodos" element={<Periodos />} />
           <Route path="/solicitacao-reserva" element={<SolicitacaoReserva />} />
        <Route path="/solicitacao-reserva/:token" element={<SolicitacaoReserva />} />
     

        <Route path="contato" element={<Contato />} />
    
        <Route path="algodeuerrado" element={<AlgoDeuErrado />} />
        <Route path="infoEmpreendimento" element={<InfoEmpreendimento />} />

        <Route path="sempermissao" element={<SemPermissao />} />
        <Route path="ajuda" element={<Ajuda />} />
     



        
      </Routes>
    </QueryParamProvider>
    <React.StrictMode>
      <GlobalStyle />
    </React.StrictMode>
  </BrowserRouter>
);
